






















# import settings from '@/settings'
import t from '@/utils/tools'

export default {
    name: 'popover_content'

    props: {
        event:{
            required: true
            type: Object
        }
    }

    computed:
        start_date: ()->
            date = ""
            if @event.allDay
                date = @date_formatter(@event.startStr)
            else
                date = @datetime_formatter(@event.startStr)
            return date

        end_date: ()->
            date = ""
            if @event.allDay
                date = @date_formatter(@event.endStr)
            else
                date = @datetime_formatter(@event.endStr)
            return date

        all_day: ()->
            return @event.allDay

        one_user: ()->
            return @event.extendedProps.asked_user_fullnamejobs == null

    methods:
        datetime_formatter: t.datetime_formatter
        date_formatter: t.date_formatter
 
    # beforeMount: ()->
    #     console.log "CONTENT EVENT user ", @event.extendedProps.user_fullnamejobs
    #     console.log "CONTENT EVENT asked_user ", @event.extendedProps.asked_user_fullnamejobs
    #     console.log "CONTENT EVENT start ", @event.startStr
    #     console.log "CONTENT EVENT end", @event.endStr
    #     console.log "CONTENT EVENT title ", @event.title
    #     console.log "CONTENT EVENT allday ", @event.allDay

}

